import { styled } from '@/stitches.config';
import { ReactComponent as CheckedRadioIcon } from '@assets/icons/radio-btn-on.svg';
import { ReactComponent as RadioIcon } from '@assets/icons/radio-btn-off.svg';
import { Box, Label } from '@base-app';

const radioStyles = {
  $$checkboxDisabled: '$colors$coolGray100',
  alignContent: 'space-around',
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  height: '$5',
  justifyContent: 'center',
  width: '$5',

  variants: {
    disabled: {
      true: {
        color: '$coolGray100',
        cursor: 'not-allowed',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
};

export const RadioContainerStyled = styled(Box, {
  position: 'relative',
  width: '$9',
  height: '$9',
  borderRadius: '$round',
  display: 'flex',
  alignContent: 'space-around',
  justifyContent: 'center',
  alignItems: 'center',

  variants: {
    disabled: {
      true: {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
});

export const RadioStyled = styled('input', {
  opacity: '0',
  position: 'absolute',
  margin: '$0',
  border: 'none',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
});

export const RadioLabelStyled = styled(Label, {
  paddingRight: '$2',
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    borderRadius: '$radii$4',
    backgroundColor: '$blue800',
  },
  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
});

export const StyledRadioText = styled(Box, {
  textAlign: 'left',
  color: '$darkBlue300',
  fontWeight: '$regular',
  fontSize: '$md',
  lineHeight: '$4',
  marginTop: '$1',
  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',
        color: '$darkGray600',
      },
    },
    selected: {
      true: {
        fontWeight: '$bold',
      },
    },
  },
});

export const RadioLabelTextStyled = styled('span', {});

export const CheckedRadioIconStyled = styled(CheckedRadioIcon, {
  ...radioStyles,
  color: '$darkBlue300',
});

export const RadioIconStyled = styled(RadioIcon, {
  ...radioStyles,
  color: '$darkGray200',
});
